module.exports = __webpack_public_path__ + "static/media/cloud-d3-v3.de5fa9dc.svg";